enum RepaymentMethod {
  ANNUITY = 'ANNUITY',
  SERIAL = 'SERIAL',
}

export default RepaymentMethod;
